import * as Yup from "yup";

export interface GravitySetting {
  id?: string;
  settingName: string;
  oid: string;
  authToken: string;
  isActive?: boolean;
  isDeleted?: boolean;
  isDefault: boolean;
}

export const GravitySettingInitialValues: GravitySetting = {
  id: "",
  settingName: "",
  oid: "",
  authToken: "",
  isActive: true,
  isDeleted: false,
  isDefault: false,
};

export const GravitySettingValidationSchema = Yup.object().shape({
  settingName: Yup.string().required("Setting Name is a required field"),
  oid: Yup.string().required("OID is a required field"),
  authToken: Yup.string().required("Auth Token is a required field"),
});

export interface PayPalSetting {
  id?: string;
  settingName: string;
  clientId: string;
  secretKey: string;
  isActive?: boolean;
  isDeleted?: boolean;
  isDefault: boolean;
}

export const PayPalSettingInitialValues: PayPalSetting = {
  id: "",
  settingName: "",
  clientId: "",
  secretKey: "",
  isActive: true,
  isDeleted: false,
  isDefault: false,
};

export const PayPalSettingValidationSchema = Yup.object().shape({
  settingName: Yup.string().required("Setting Name is required"),
  clientId: Yup.string().required("Client Id is required"),
  secretKey: Yup.string().required("Secret Key is required"),
});

export const EditPayPalSettingValidationSchema = Yup.object().shape({
  settingName: Yup.string().required("Setting Name is required"),
  clientId: Yup.string().required("Client Id is required"),
});
